import React from 'react'
import { TextField, Typography } from '@mui/material'

const DemographicInfo = ({ contactValues, handleContactFieldChange, Row }) => {
  return (
    <>
      <Typography variant='h6' sx={{ textAlign: 'left', marginTop: '16px' }}>
        Contact Information
      </Typography>
      <Row>
        <TextField
          margin='dense'
          sx={{ minWidth: '200px', flexGrow: 1, mr: 1 }}
          value={contactValues.firstName}
          onChange={(e) => {
            handleContactFieldChange({
              ...contactValues,
              firstName: e.target.value,
            })
          }}
          required
          label='First Name'
        />
        <TextField
          margin='dense'
          sx={{ minWidth: '200px', flexGrow: 1, mr: 1 }}
          value={contactValues.lastName}
          onChange={(e) => {
            handleContactFieldChange({
              ...contactValues,
              lastName: e.target.value,
            })
          }}
          required
          label='Last Name'
        />
      </Row>
      <TextField
        margin='dense'
        fullWidth
        value={contactValues.email}
        onChange={(e) => {
          handleContactFieldChange({
            ...contactValues,
            email: e.target.value,
          })
        }}
        required
        label='Email'
      />
      <TextField
        margin='dense'
        fullWidth
        value={contactValues.companyName}
        onChange={(e) => {
          handleContactFieldChange({
            ...contactValues,
            companyName: e.target.value,
          })
        }}
        required
        label='Company Name'
      />
      <TextField
        margin='dense'
        fullWidth
        value={contactValues.title}
        onChange={(e) => {
          handleContactFieldChange({
            ...contactValues,
            title: e.target.value,
          })
        }}
        required
        label='Title'
      />
    </>
  )
}

export default DemographicInfo
